import React, { useCallback, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import updateTypeService from '../services/updateTypeService';
import typeService from '../services/typeService';
import TypeForm from './TypeForm';
import { mapFormToIdentificationCodeType } from '../helpers/mapFormToIdentificationCodeType';

const EditType = ({
  open,
  dispatchUpdateIdentificationCodeTypePut,
  updateIdentificationCodeTypeFetch,
  dispatchIdentificationCodeTypeGet,
  identificationCodeTypeFetch,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const handleSubmit = useCallback(
    body =>
      dispatchUpdateIdentificationCodeTypePut(
        id,
        mapFormToIdentificationCodeType(body),
        () => navigate(`/identificationcodetypes`),
        t
      ),
    [id, dispatchUpdateIdentificationCodeTypePut, t, navigate]
  );

  useEffect(() => {
    if (open && id) {
      dispatchIdentificationCodeTypeGet(id, () => navigate('/identificationcodetypes'), t);
    }
  }, [id, open, t, dispatchIdentificationCodeTypeGet, navigate]);

  const defaultData = useMemo(
    () =>
      !identificationCodeTypeFetch.pending && {
        ...(identificationCodeTypeFetch.value || {}),
        validationPatternId: identificationCodeTypeFetch.value?.validationPattern?.id,
        owners: identificationCodeTypeFetch.value?.owners?.map(o => ({
          communityId: o.community?.id,
          organisationId: o.organisation?.id,
        })),
      },
    [identificationCodeTypeFetch]
  );

  if (!open) return null;

  return (
    <TypeForm
      header={identificationCodeTypeFetch.value?.name}
      onSubmit={handleSubmit}
      submitProcessing={updateIdentificationCodeTypeFetch.pending}
      returnRoute="/identificationcodetypes"
      cancelRoute="/identificationcodetypes"
      dataLoading={identificationCodeTypeFetch.pending}
      data={defaultData}
      showRemoveButton
      editMode
    />
  );
};

EditType.propTypes = {
  dispatchUpdateIdentificationCodeTypePut: PropTypes.func.isRequired,
  updateIdentificationCodeTypeFetch: PropTypes.object.isRequired,
  dispatchIdentificationCodeTypeGet: PropTypes.func.isRequired,
  identificationCodeTypeFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

EditType.defaultProps = { open: false };

export default compose(typeService, updateTypeService)(EditType);
